import React from 'react';
import { Scramble } from '../Scramble/Scramble.jsx';
import { MONO } from '../../primitives.js';

const h = React.createElement;

/**
 * Inline machine value in Space Mono (ids, keys, emails).
 *
 * @param {object} p
 * @param {boolean} [p.scramble]
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 * @param {string} [p.title]
 */
export function Tok({ children, style, title, scramble = true }) {
  const txt = typeof children === 'string' ? children : null;
  const inner = scramble && txt && Scramble ? h(Scramble, { text: txt, on: 'hover' }) : children;
  return h('code', { title: title || txt || undefined, style: { fontFamily: MONO, fontSize: 11, padding: '2px 6px', background: 'var(--inset)', border: '1px solid var(--line2)', borderRadius: 6, color: 'var(--tx)', whiteSpace: 'nowrap', ...style } }, inner);
}
